module.exports = __webpack_public_path__ + "img/barrier_2.bdd404da.png";